{
  "2FA Code": "2FA Code",
  "2FA Code is required": "2FA Code is required",
  "Address": "Address",
  "All": "All",
  "Almost there!": "Almost there!",
  "An unexpected error occurred": "An unexpected error occurred",
  "Application error occurred": "Application error occurred",
  "Are you sure?": "Are you sure?",
  "Budget amount update failed": "Budget amount update failed",
  "Budget data fee update failed": "Budget data fee update failed",
  "Budget percentage split update failed": "Budget percentage split update failed",
  "Budget reach update failed": "Budget reach update failed",
  "Budget reset failed": "Budget reset failed",
  "Budget view frequency update failed": "Budget view frequency update failed",
  "Campaign delete failed": "Campaign delete failed",
  "Campaign name update failed": "Campaign name update failed",
  "Campaign publish failed": "Campaign publish failed",
  "Campaign stages update failed": "Campaign stages update failed",
  "Campaign timeline update failed": "Campaign timeline update failed",
  "Campaign update failed": "Campaign update failed",
  "Change password": "Change password",
  "Choose a client": "Choose a client",
  "Client has been created!": "Client has been created!",
  "Client has been updated!": "Client has been updated!",
  "Code must contains 6 characters": "Code must contain 6 characters",
  "Details": "Details",
  "Drag and drop a file to upload": "Drag and drop a file to upload",
  "Email": "Email",
  "Email address": "Email address",
  "Email address required": "Email address required",
  "Email incorrect!": "Email incorrect!",
  "Email is required": "Email is required",
  "Email required!": "Email required!",
  "Empty list": "Empty list",
  "Error": "Error",
  "Error occured": "Error occurred",
  "Error occurred": "Error occurred",
  "Error occurred while saving campaign": "Error occurred while saving campaign",
  "Error occurred!": "Error occurred!",
  "Forgot your password?": "Forgot your password?",
  "GLOBAL_SEARCH": {
    "LIST": {
      "HEADER": "Global search"
    }
  },
  "Incorrect email address": "Incorrect email address",
  "CONTENT_AUDIT": {
    "LIST": {
      "HEADER": "Content audit"
    },
    "AUTO_AUDIT": {
      "RESULTS": {
        "ACCEPT": "Accept",
        "DUBIOUS": "Dubious",
        "VALIDATE": "Validate",
        "REJECT": "Reject",
        "UNKNOWN": "Unknown"
      }
    }
  },
  "LOCKSCREEN": {
    "COPIED_TO_CLIPBOARD": {
      "CLOSE": "Close",
      "LABEL": "Copied to clipboard!"
    },
    "DETAILS": {
      "BUTTONS": {
        "CANCEL": "Cancel",
        "CONFIRM": "Confirm",
        "REJECT": "Reject",
        "REJECTION_REASON": "Rejection reason",
        "APPROVE": "Approve",
        "WITHDRAW": "Withdraw",
        "RESUME": "Resume",
        "RE_AUDIT": "Re-Audit",
        "PUBLISH": "Publish"
      },
      "DIALOGS": {
        "REJECT": {
          "DESCRIPTION": "Description",
          "INFO": "Please select the rejection reason for the campaign",
          "REASON": "Reason",
          "REJECTION_CUSTOM_REASON": "Rejection reason",
          "REJECTION_DESCRIPTION": "Rejection description",
          "REJECTION_REASON": "Rejection reason",
          "SELECT_REJECTION_REASON": "Select reason",
          "TITLE": "Are you sure?",
          "TOOLTIP": "Please provide rejection reason"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "Try again later!",
        "TITLE": "Empty"
      },
      "ERROR": {
        "DESCRIPTION": "Try again later!",
        "SNACKBAR_TEXT": "An unexpected error occurred.",
        "TITLE": "An unexpected error occurred."
      },
      "INFO": "Please scroll down to review the following details of the lock screen campaign",
      "LABELS": {
        "AUDIENCE": "Audience",
        "CAMPAIGN_NAME": "Campaign name",
        "CATEGORY": "Category",
        "CONTENT": "Content",
        "COPYRIGHT": "Copyright",
        "COUNTRIES": "Markets",
        "CTA": "CTA",
        "DESCRIPTION": "Description",
        "DURATION": "Duration",
        "DURATION_IN_DAYS": "Duration in days",
        "IMAGE_PROVIDER": "Image provider",
        "LANDING_PAGE_URL": "Landing page URL",
        "LANGUAGE": "Language",
        "NAME": "Name",
        "PUBLICATION": "Publication",
        "PUBLISHER": "Publisher",
        "START_DATE": "Start date",
        "TAGS": "Tags",
        "TARGET_LANGUAGES": "Target languages",
        "TITLE": "Title",
        "TYPE": "Type",
        "AUTO_AUDIT_TIME": "Auto audit time",
        "HUMAN_AUDIT_TIME": "Human audit time",
        "ID": "ID",
        "IMAGE": "Image",
        "IMAGE_PREVIEW": "Image preview",
        "LINK": "Link",
        "MARKET": "Market",
        "PREVIEW": "Preview",
        "PREVIEW_ALL": "Preview all",
        "REAL_PHONE": "Real phone",
        "REAL_PHONE_PREVIEW": "Real phone preview",
        "REVIEW_LOCK_SCREEN_RESOURCE": "Review lock screen resource",
        "SAFE_ZONE": "Safe zone",
        "SAFE_ZONE_PREVIEW": "Safe zone preview",
        "URL": "URL",
        "REVIEWING": "Reviewing {{current}} of {{total}}",
        "PREVIOUS": "Previous",
        "NEXT": "Next"
      },
      "STATUS_UPDATED": {
        "TITLE": "Campaign status has been changed."
      },
      "TABS": {
        "AUDIENCE": "Audience",
        "CONTENT": "Content",
        "DURATION": "Duration",
        "PUBLISHER": "Publisher"
      }
    },
    "FILTERS": {
      "ADVERTISER": {
        "OPTIONS": {
          "ALL": "All"
        }
      },
      "CATEGORY": {
        "OPTIONS": {
          "ALL": "All"
        }
      },
      "LANGUAGE": {
        "OPTIONS": {
          "ALL": "All",
          "ENGLISH": "English",
          "INDONESIAN": "Indonesian",
          "MALAY": "Malay",
          "THAI": "Thai",
          "VIETNAMESE": "Vietnamese",
          "FRENCH": "French",
          "SPANISH": "Spanish"
        }
      },
      "RESOURCE_TYPE": {
        "OPTIONS": {
          "ALL": "All",
          "CAMPAIGN": "Campaign",
          "CONTENT": "Content",
          "REPORTS": "Reports"
        }
      }
    },
    "LIST": {
      "BUTTONS": {
        "OPEN_DETAILS": "Details"
      },
      "COLUMNS": {
        "AUDIT": {
          "PASS": "Pass",
          "DUBIOUS": "Dubious",
          "FAIL": "Fail",
          "TITLE": {
            "LABEL": "Title"
          },
          "DESCRIPTION": {
            "LABEL": "Description"
          },
          "IMAGE": {
            "LABEL": "Image"
          },
          "H5": {
            "LABEL": "H5"
          }
        },
        "AUDITOR": {
          "LABEL": "Auditor"
        },
        "AUTO_AUDIT_RESULT": {
          "LABEL": "Auto audit result"
        },
        "AUTO_AUDIT_TIME": {
          "LABEL": "Auto audit time"
        },
        "AVG_TIME_ARTICLE": {
          "LABEL": "AVG Time spent on article"
        },
        "AVG_TIME_LOCKSCREEN": {
          "LABEL": "AVG Time spent on LS image"
        },
        "CATEGORY": {
          "LABEL": "Category"
        },
        "CLICKS": {
          "LABEL": "Clicks"
        },
        "COUNTRIES": {
          "LABEL": "Markets"
        },
        "CTR": {
          "LABEL": "CTR"
        },
        "DURATION": {
          "LABEL": "Duration in days"
        },
        "HUMAN_AUDIT_TIME": {
          "LABEL": "Human audit time"
        },
        "ID": {
          "COPY_TO_CLIPBOARD": "Copy ID to clipboard!",
          "VALUE": "ID: {{value}}",
          "LABEL": "ID"
        },
        "IMPRESSIONS": {
          "LABEL": "Impressions"
        },
        "LANGUAGE": {
          "LABEL": "Language"
        },
        "OEM": {
          "LABEL": "Oem"
        },
        "REJECTED_REASON": {
          "LABEL": "Rejection reason"
        },
        "REJECTED_REASON_DESCRIPTION": {
          "LABEL": "Rejection reason description"
        },
        "RESOURCE_TYPE": {
          "LABEL": "Resource type"
        },
        "START_DATE": {
          "LABEL": "Start date"
        },
        "STATUS": {
          "LABEL": "Status"
        },
        "TITLE": {
          "EMPTY_LABEL": "NO TITLE"
        }
      },
      "EMPTY": {
        "DESCRIPTION": "Try changing the keywords or filters.",
        "TITLE": "No results for selected criteria."
      },
      "ERROR": {
        "DESCRIPTION": "Try again later!",
        "TITLE": "An unexpected error occurred."
      },
      "FILTERS": {
        "ADVERTISER": {
          "LABEL": "Advertiser"
        },
        "CATEGORY": {
          "LABEL": "Category"
        },
        "COUNTRY": {
          "LABEL": "Market"
        },
        "DATEPICKER": {
          "AUTO_AUDIT_TIME": "Auto audit time",
          "START_END_TIME": "Start / end time",
          "DATE_RANGE": "Date range",
          "HUMAN_AUDIT_TIME": "Human audit time",
          "PRESETS": {
            "ALL": "All",
            "CURRENT_MONTH": "Current month",
            "LAST_7_DAYS": "Last 7 days",
            "NEXT_MONTH": "Next month",
            "PREVIOUS_MONTH": "Previous month",
            "TODAY": "Today"
          },
          "PUBLISH_LABEL": "Publish date range"
        },
        "LANGUAGE": {
          "LABEL": "Language"
        },
        "SORT_BY": {
          "LABEL": "Sort by"
        },
        "SORT_ORDER": {
          "LABEL": "Sort order"
        },
        "STATUS": {
          "LABEL": "Status"
        },
        "RESET": "Reset filters"
      },
      "HEADER": "Lock screen campaigns",
      "METRICS": {
        "INFO": "All metrics are based on the aggregate data since the campaign's initiation. Date selection does not influence the displayed data.",
        "LABEL": "Metrics"
      },
      "TOTAL_ELEMENTS": {
        "LABEL": "Total: {{value}}"
      }
    },
    "REPORTS": {
      "LOADING": "Loading report...",
      "SELECT_FILTERS": "Select filters and apply to generate the report.",
      "GENERATE": "Generate",
      "GENERATE_TITLE": "Generate report",
      "LIST": {
        "HEADER": "Reports"
      },
      "TYPE": {
        "CONTENT": "Content",
        "WORKLOAD": "Workload",
        "AUDIT_RATE": "Audit rate"
      },
      "WORKLOAD": {
        "HEADER": "Workload report"
      },
      "CONTENT": {
        "HEADER": "Content report"
      },
      "AUDIT_RATE": {
        "HEADER": "Audit rate report"
      }
    },
    "SHARED": {
      "DATEPICKER": {
        "END_DATE": "End date",
        "ENTER_DATE_RANGE": "Active campaign date range",
        "START_DATE": "Start date"
      },
      "SEARCH": {
        "LABEL": "Search"
      },
      "SNACKBAR": {
        "CHECK_DETAILS": "Check details"
      }
    },
    "STATUSES": {
      "ALL": "All",
      "APPROVED": "Approved",
      "CANCELLED": "Cancelled",
      "EXPIRED": "Expired",
      "IN_REVIEW": "In review",
      "LIVE": "Live",
      "REJECTED": "Rejected"
    }
  },
  "Login": "Login",
  "New password": "New password",
  "No results for selected criteria": "No results for selected criteria.",
  "Notification create failed": "Notification create failed.",
  "Notification name update failed": "Notification name update failed.",
  "Password": "Password",
  "Password doesn't match": "Password doesn't match",
  "Password is required": "Password is required",
  "Password must contain at least one numeric character": "Password must contain at least one numeric character",
  "Password required": "Password required",
  "Passwords must be at least 8 characters in length": "Passwords must be at least 8 characters in length",
  "Repeat password": "Repeat password",
  "Reset password": "Reset password",
  "Return": "Return",
  "Role has been changed!": "Role has been changed!",
  "Search category name": "Search category name",
  "Stores in": "Stores in",
  "Target": "Target",
  "Temporary password": "Temporary password",
  "Timezone": "Timezone",
  "Total conversions": "Total conversions",
  "Traffic": "Traffic",
  "Try again later!": "Try again later!",
  "Try changing the keywords or filters": "Try changing the keywords or filters.",
  "URL address": "URL address",
  "Uploading": "Uploading...",
  "User has been already added!": "User has been already added!",
  "User has been removed!": "User has been removed!",
  "add": "Add",
  "app": {
    "adblock": {
      "done": "Done - reload application",
      "text": "Browser extensions such as AdBlock or similar will prevent this application from working correctly. Please disable them now.",
      "title": "Please disable your ad blocking software"
    }
  },
  "budgetDetails": {
    "accountingFee": "Accounting fee",
    "budgetDetails": "Budget details",
    "dataFee": "Data fee",
    "netMedia": "Net media",
    "tax": "Tax"
  },
  "button": {
    "addNewCampaign": "Add new campaign",
    "addYourFile": "Add your file",
    "approve": "Approve",
    "backToDashboard": "Back to dashboard",
    "campaignSummary": "CAMPAIGN SUMMARY",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "continue": "Continue",
    "create": "Create",
    "delete": "Delete",
    "downloadCampaignProposal": "Download campaign proposal",
    "downloadSpotplan": "Download spotplan",
    "edit": "Edit",
    "login": "Log in",
    "nextStep": "Next step",
    "ok": "OK",
    "previous": "Previous",
    "previousStep": "Previous step",
    "reject": "Reject",
    "report": "Report",
    "resetPassword": "Reset password",
    "save": "Save",
    "sendForReview": "Send for review",
    "showReport": "Show report",
    "summary": "Summary"
  },
  "campaign": {
    "targetType": {
      "all": "All"
    }
  },
  "clear all": "Clear all",
  "clientInvitation": {
    "getStarted": "Get started",
    "instead": "instead",
    "invalidToken": "Invalid token",
    "passwordRequirerments": {
      "digit": "at least one digit",
      "lowerCaseLetter": "at least one lower case letter",
      "minLength": "min. length (12 characters)",
      "mustContain": "Password must contain",
      "upperCaseLetter": "at least one upper case letter"
    },
    "passwordsDoNotMatch": "Passwords do not match",
    "setup": "Let's get your account set up. It will take a minute.",
    "setupProfile": "Set up your profile",
    "signedUpWith": "You will be signed up with the email",
    "toCosmose": "to Cosmose Media",
    "welcome": "Welcome",
    "wrongAccount": "Wrong account?"
  },
  "clients": {
    "addNewClient": "Add new client",
    "addTeamMember": "Add team member",
    "category": "Category",
    "clientDetails": "Client details",
    "clientName": "Client name",
    "clients": "Clients",
    "companyAddress": "Company address",
    "companyName": "Company name",
    "country": "Market",
    "createNewClient": "Create a new client",
    "createSuccessDialog": {
      "addTeammates": "Add teammates",
      "clientCreated": "Great! Client has been created",
      "inviteTeammates": "Invite your teammates to collaborate",
      "planCampaign": "Plan campaign"
    },
    "currency": "Currency",
    "goBack": "Go back",
    "invalidName": "Invalid name",
    "teamMembersDialog": {
      "addTeamMembers": "Add team members for {{clientName}}",
      "invitationSent": "Invitation has been sent.",
      "invitedMembers": "Invited members",
      "noUsers": "No one has been added to this client yet",
      "openInvitedMembers": "Open then \"Invited members\" tab to manage the list.",
      "removeUser": "Remove user",
      "sendInvite": "Send invite",
      "typeEmailAddress": "Type email address"
    },
    "timezone": "Timezone",
    "typeClientName": "Type client's name"
  },
  "e": {
    "g": {
      " https://www": {
        "kaikai": {
          "ai": "e.g. https://www.kaikai.ai"
        }
      }
    }
  },
  "error": {
    "email": "Please enter a valid email address",
    "repeatNotSame": "Password does not match",
    "required": "Field is required"
  },
  "guidedTour": {
    "stepPagination": "{{currentStepNumber}} of {{numberOfSteps}}"
  },
  "label selected": "label selected",
  "label": {
    "age": "Age",
    "audienceEstimation": "Audience estimation",
    "avgFrequency": "Avg. Frequency",
    "brandOwnStores": "Brand own stores",
    "budgetOf": "of",
    "budgetSpent": "Budget spent",
    "campaignDuration": "Campaign duration",
    "campaignName": "Campaign name",
    "campaigns": "Campaigns",
    "cities": "Cities",
    "competitors": "Competitors",
    "congratulations": "Congratulations!",
    "currentPassword": "Temporary password",
    "emailAddress": "Email address",
    "gender": "Gender",
    "genderType": {
      "ALL": "All",
      "FEMALE": "Female",
      "MALE": "Male"
    },
    "mediaSpotPlan": "Media spotplan",
    "password": "Password",
    "perViewer": "per viewer",
    "reach": "Reach",
    "relevantLocationCategories": "Relevant location categories",
    "repeatPassword": "Repeat password",
    "status": "Status",
    "statuses": {
      "ALL": "All"
    },
    "success": "Success",
    "visitsPeriod": "Visits period"
  },
  "labels selected": "labels selected",
  "mainHeader": {
    "Content audit": "Content audit",
    "Global search": "Global search",
    "Lockscreen campaigns": "Lock screen campaigns",
    "Media campaigns": "Media campaigns",
    "Notifications": "Notifications"
  },
  "HONOR_LAYOUT": {
    "SECTIONS": {
      "AUDIT": "Audit",
      "REPORTS": "Reports",
      "SETTINGS": "Settings"
    },
    "ITEMS": {
      "CONTENT_AUDIT": "Content audit",
      "REJECTION_REASONS": "Rejection reasons",
      "REPORTS": "Reports",
      "WORKLOAD": "Workload",
      "CONTENT": "Content",
      "AUDIT_RATE": "Audit rate",
      "MANAGE_ACCESS": "Manage access"
    }
  },
  "FILTERS": {
    "FIELD": {
      "AUDITORS": "Auditors",
      "AUDIT_GROUP": "Audit Group",
      "HONOR_CATEGORY": "Category",
      "HONOR_LANGUAGE": "Language",
      "REJECTION_REASONS": "Rejection Reasons"
    },
    "NONE": "None",
    "GLOBAL": "Global",
    "OPTIONS": {
      "ALL": "All"
    }
  },
  "page": {
    "campaign": {
      "budgetTip": "Presented value is a budget estimation. Our calculation is based on audience size as well as additional parameters - average view frequency and percentage reach multiplied by CPM. This amount also includes the fee for using our location services.",
      "details": "Details",
      "estimatedAudienceSize": "Est. audience size",
      "estimatedAudienceSizeCalculating": "Est. audience size is calculating...",
      "estimatesTip": "This is an estimated size of your target audience. It changes dynamically while you adjust parameters like stores people visit, demographics, platform-specific settings.",
      "searchCampaignByName": "Search campaign by name",
      "submitForReviewContact": "Cosmose Account manager will contact you in 4 working hours via email",
      "submitForReviewSuccess": "Your campaign \"{{campaignName}}\" has been sent for review"
    },
    "campaigns": {
      "chineseTouristsCampaign": "Chinese tourists campaign",
      "localCampaign": "Local campaign",
      "title": "Welcome back!"
    },
    "error": {
      "403": {
        "title": "Forbidden error"
      },
      "404": {
        "title": "Page not found"
      },
      "500": {
        "title": "Internal Server Error"
      }
    },
    "execution": {
      "ad-preview": {
        "dpsHasNotYet": "DSP has not uploaded \"Ad previews\" yet.",
        "headerTitle": "Ad preview confirmation",
        "letYouKnow": "We will let you know via email when \"Ad previews\" will be ready for your review."
      },
      "comments": "Comments",
      "creative-censorship": {
        "headerTitle": "Creative Verification",
        "tooltip": "This process will take at least 3 working days. \nPlease upload creatives prior to the deadline."
      },
      "legal-censorship": {
        "headerTitle": "Legal Verification"
      },
      "mobile": {
        "executionPhase": "Execution phase",
        "useDesktopVersion": "Please use a desktop version to preview this step"
      },
      "modal": {
        "addComment": "Add a comment",
        "areYouSure": "Are you sure you want to",
        "file": "File",
        "mandatoryField": "This field is mandatory",
        "sendForReview": "Send for review",
        "thisItem": "this item?",
        "wouldYouLikeToSendThisFileForReview": "Would you like to send this file for review?"
      },
      "sendForReviewModal": {
        "creativeVerification": "Thanks for submitting the creatives, we will have the media platform to review it and get back to you within 3 working days.",
        "legalVerification": "Thanks for submitting the legal docs, we will have the media platform to review it and get back to you within 3 working days.",
        "trackingCodes": "Thanks for submitting the tracking codes, we will have the media platform to review it and get back to you within 2 working days."
      },
      "tracking-codes": {
        "chooseTrackingCodes": "Choose which tracking codes would you like to upload",
        "headerTitle": "Tracking codes setting",
        "pageUrl": "Landing page url"
      },
      "uploadNewDocument": "Upload new document"
    },
    "login": {
      "2faSubtitle": "Get a verification code from google Authenticator app",
      "2faTitle": "2-step verification",
      "back": "Back",
      "credentialsError": "Wrong credentials. Try again.",
      "enterACode": "Enter a code",
      "forgotPassword": "Forgot your password?",
      "invalidToken": "Wrong code. Try again.",
      "next": "Next",
      "title": "Log in"
    },
    "objective": {
      "chineseTourists": {
        "targetGroup": "Chinese tourists",
        "title": "Where is your destination?"
      },
      "clients": {
        "addNewClient": "Add new client",
        "selectClient": "Select client"
      },
      "createYourOwnGoal": "Create your own goal",
      "goalName": "Goal name",
      "localAudience": {
        "targetGroup": "Local audience",
        "title": "What is your goal?"
      },
      "target": "Target"
    },
    "planner": {
      "audience": {
        "addAnother": "Add another +",
        "businessCategories": "Business Categories",
        "chooseBusinessCategories": "Business Categories",
        "cosmoseAiRecommendationTooltipLine1": "Campaign preset is Cosmose AI recommendation",
        "cosmoseAiRecommendationTooltipLine2": "If you want to start from scratch switch toggle",
        "cosmoseAiRecommendationTurnOff": "Cosmose AI off",
        "cosmoseAiRecommendationTurnOn": "Cosmose AI on",
        "other": "Other",
        "ownStoresTooltip": "Just looking - People who visited your store but left before making a purchase\n\nWindow shoppers - People who spent time outside your store and didn't visit it\n\nYour customers - People who bought items in your store",
        "question": "Where does your target audience shop?",
        "selectCitiesHint": "Select cities for above locations to capture your audience",
        "selectDurationDesc": "At least once in the period",
        "selectDurationHint": "Select duration for audience capture",
        "selectDurationTooltip": "E.g. past 1 month/3 months",
        "selectLocationsHint": "Select locations to capture your audience"
      },
      "backToDashboard": "Back to dashboard",
      "budget": {
        "apply": "APPLY",
        "changedBudgetHint": "Before you \"Continue\" please \"Apply\" budget first",
        "disabledDuringtripTip": "Your campaign would be running only for \"During trip\" phase",
        "maxBudgetHint": "Maximum budget is {{value}}",
        "minBudgetHint": "Minimum budget is {{value}}",
        "question": "What's your budget for the campaign?",
        "resetToDefaultSetup": "Reset to default setup",
        "totalCampaignBudget": "Total campaign budget"
      },
      "deselectAll": "Deselect all",
      "downloadBudget": "Download budget quotation",
      "downloadLocationsList": "Download locations list",
      "downloadRequirements": "Download requirements",
      "files": {
        "summary": {
          "header": "Additional campaign files"
        }
      },
      "groups": {
        "addInterests": "Add interests +",
        "educationLevel": "Education level",
        "income": "Income",
        "interests": "Interests",
        "nationWide": "Nationwide",
        "question": "Which groups do you want to reach?",
        "searchBehaviour": "Search behaviour",
        "specificCities": "Specific cities",
        "targetMarkets": "Which city would you like to target?"
      },
      "guidedTour": {
        "action": {
          "exitDemo": "Exit demo",
          "next": "Next"
        },
        "startDemoModal": {
          "introduction": "Great to have you on board. We've prepared a short tutorial to guide you through the most important features of Cosmose Media",
          "startDemo": "Start demo",
          "timespan": "It will take around 5 minutes.",
          "welcome": "Welcome"
        }
      },
      "label": {
        "BEFORE_TRIP": "Before trip",
        "DURING_TRIP": "During trip"
      },
      "media": {
        "dailyUsers": "Daily users",
        "deselectAllPlatforms": "Deselect all platforms",
        "downloads": "Downloads",
        "platformBudgetTooLow": "In order to use this platform the budget needs to be at least {{value}}",
        "question": "Which media would you like to use?",
        "selectAllPlatforms": "Select all platforms"
      },
      "platformGroup": {
        "details": "Details"
      },
      "platformListSelection": {
        "show": "Show"
      },
      "platformNameFilter": {
        "searchAppByName": "Search app by name"
      },
      "selectAll": "Select all",
      "timeline": {
        "question": "Campaign spot plan",
        "spotplan": {
          "adFormat": "Ad Format",
          "audienceExplanation": "Audience explanation",
          "averageFrequency": "Average Frequency",
          "buyingModel": "Buying model",
          "cosmoseAiDataFee": "Cosmose AI data fee",
          "cosmoseAiDataFeeLocations": "1 - 500 locations",
          "cosmoseServiceFee": "Cosmose service fee",
          "cosmoseServiceFeeInvestment": "3% of net media investment",
          "maxUnitPrice": "Max. Unit Price",
          "media": "Media",
          "numberOfImpressions": "Number of Impressions",
          "potentialCustmersReached": "Potential Customers Reached (estimation)",
          "regionAndSchedule": "Region and schedule",
          "totalBudgetIncludingVat": "TOTAL BUDGET (including 6% VAT)",
          "totalCost": "Total cost"
        }
      }
    },
    "report": {
      "All segments": "All segments",
      "brandPreferences": {
        "showBrandPreferences": "Show brand preferences for",
        "tooltip": "Presented data have been collected since the beginning of the campaign duration"
      },
      "campaignReport": "Campaign report.xlsx",
      "delayDataTip": "Data on the report appears with a delay after it's been processed by our data partners",
      "details": "Details",
      "downloadReport": "Download report",
      "filter": "Filter",
      "filterBy": "Filter by",
      "metricsTooltips": {
        "backToAllMetrics": "Back to All metrics",
        "conversions": "Conversions data appears with a delay after the campaign has been completed."
      },
      "metricsType": {
        "averageFrequency": "Avg. Frequency",
        "clickThroughRate": "CTR",
        "clicks": "Clicks",
        "costPerClick": "CPC",
        "costPerMille": "CPM",
        "impressions": "Impressions",
        "postComments": "Post comments",
        "postEngagements": "Post Engagements",
        "postReactions": "Post Reactions",
        "postShares": "Post Shares",
        "uniqueViews": "UV",
        "videoP100watchedActions": "100% Video view"
      },
      "noDataMessage": "No report data available yet",
      "overview": "Overview",
      "postBuyReport": "Post-buy report.pptx",
      "summary": "Summary"
    },
    "resetPassword": {
      "description": "and  we’ll send you a link to reset your password.",
      "enterNewPassword": "Enter new password",
      "goToLoginScreen": "Go to login screen",
      "lengthConstraints": "Passwords must be at least 12 characters in length",
      "passwordChanged": "Your password has been changed successfully!",
      "patternConstraints": "Password must contain at least one lowercase letter, one uppercase letter and one numeric character",
      "thankYou": "Thank you.",
      "title": "Enter your email address"
    },
    "summary": {
      "sendForReviewHint1": "Once you click “Send for review” button your submission cannot be changed",
      "sendForReviewHint2": "If you need to make any changes please contact Cosmose Account Manager.",
      "totalCampaignBudget": "Total campaign budget"
    }
  },
  "popup": {
    "popupCampaignName": {
      "campaignName": "Campaign name",
      "charactersLimit": "max. 36 characters",
      "edit": "Edit name"
    }
  },
  "profile": {
    "help": "Help",
    "logout": "Log out",
    "settings": {
      "authenticatorApp": "Authenticator app",
      "authenticatorAppDescription": "Use the Authenticator app to get free verification codes",
      "confirm": "Confirm",
      "confirmDisable2faMessage": "Click 'save and log out'. It will log you out and disable 2FA usage",
      "confirmEnable2faMessage": "Click 'save and log out'. It will log you out and enforce next login using 2FA",
      "disableTwoStepVerification": "Disable 2-Step Verification",
      "downloadApp": "Download Authenticator App",
      "downloadAuthenticatorApp": "Download Google Authenticator App (or anything else supporting TOTP)",
      "enableTwoStepVerification": "Enable 2-Step Verification",
      "enterOtp": "Enter OTP",
      "next": "Next",
      "off": "Off",
      "on": "On",
      "saveAndLogout": "Save and log out",
      "settings": "Settings",
      "setup": "Set up",
      "twoStepVerification": "2-Step Verification",
      "verify": "Verify"
    }
  },
  "pushNotifications": {
    "+ {{value}} more": "+ {{value}} more",
    "Back": "Back",
    "Back to dashboard": "Back to dashboard",
    "Brands": "Brands",
    "Campaign name": "Campaign name",
    "Campaign timeline": "Campaign timeline",
    "Cities": "Cities",
    "Client": "Client",
    "Create new campaign": "Create new campaign",
    "Create new notification": "Create new notification",
    "Create notification": "Create notification",
    "Delete": "Delete",
    "Edit": "Edit",
    "Edit notification name": "Edit notification name",
    "End": "End",
    "Hurray!": "Hurray!",
    "Leave setup": "Leave setup",
    "Next": "Next",
    "No": "No",
    "Notification create failed": "Notification create failed",
    "Notification delete failed": "Notification delete failed",
    "Notification deleted": "Notification deleted",
    "Notification name": "Notification name",
    "Notification name update failed": "Notification name update failed",
    "Notification start failed": "Notification start failed.",
    "Notification update failed": "Notification update failed",
    "Notification updated": "Notification updated",
    "Notifications": "Notifications",
    "Notifications setup summary": "Notifications setup summary",
    "Please confirm deleting the campaign": "Please confirm deleting the campaign",
    "Please confirm stopping the campaign": "Please confirm stopping the campaign",
    "Search by name": "Search by name",
    "Select end date": "Select end date",
    "Select locations to capture audience": "Select locations to capture audience",
    "Select start date": "Select start date",
    "Shopping malls": "Shopping malls",
    "Start": "Start",
    "Start campaign": "Start campaign",
    "Start date must be before end date": "Start date must be before end date",
    "Status": "Status",
    "Stop campaign": "Stop campaign",
    "Timeline": "Timeline",
    "Type brand name": "Type brand name",
    "Type city name e": {
      "g": {
        " Kuala Lumpur": "Type city name e.g. Kuala Lumpur"
      }
    },
    "Type shopping mall name": "Type shopping mall name",
    "Yes": "Yes",
    "Your notifications campaign \"{{campaignName}}\" is going to start soon": "Your notifications campaign \"{{campaignName}}\" is going to start soon"
  },
  "select all": "Select all",
  "validationErrors": {
    "invalidCode": "Invalid code",
    "required": "Required"
  }
}